/**
 * 將 candidates API 正規化為 UI 列（不 fallback mock）。
 */

function resolveMtr(row) {
  const mtr = row?.mtr ?? {};
  return {
    mtrId: mtr.id ?? row?.mtrId ?? '',
    mtrNo: mtr.mtrNo ?? row?.mtrNo ?? '',
    mtrName: mtr.name ?? row?.mtrName ?? '',
  };
}

function normalizeSource(source, index) {
  const sourceType = source?.sourceType ?? 'INVENTORY_STOCK';
  const id = source?.id
    ?? source?.invStockId
    ?? source?.pendingAllocationId
    ?? `source-${index}`;
  const availableQty = Number(
    source?.availableQty ?? source?.qty ?? 0,
  ) || 0;
  const warehouse = source?.warehouse;
  const location = source?.location;
  const warehouseLabel = source?.warehouseLabel
    ?? warehouse?.name
    ?? warehouse?.label
    ?? null;
  const locationLabel = source?.locationLabel
    ?? location?.name
    ?? location?.code
    ?? location?.label
    ?? null;

  return {
    sourceType,
    id: String(id),
    stockNo: source?.stockNo ?? source?.sourceNo ?? null,
    qty: availableQty,
    sourceKey: `${sourceType}:${id}`,
    warehouseLabel,
    locationLabel,
  };
}

export function normalizeStockIssueCandidates(payload) {
  const root = payload?.data ?? payload ?? {};
  const materialsRaw = root.materials
    ?? root.list
    ?? root.items
    ?? [];

  const materials = (Array.isArray(materialsRaw) ? materialsRaw : []).map(
    (row, rowIndex) => {
      const mtr = resolveMtr(row);
      const sources = (row?.sources ?? row?.inventoryStocks ?? [])
        .map(normalizeSource)
        .filter((source) => source.id && source.qty > 0);

      return {
        key: mtr.mtrId || `material-${rowIndex}`,
        ...mtr,
        requiredQty: row?.requiredQty ?? null,
        remainingQty: row?.remainingQty ?? row?.shortageQty ?? null,
        completedIssueQty: row?.completedIssueQty ?? null,
        sources,
        isShortage: sources.length === 0,
      };
    },
  ).filter((row) => row.mtrId);

  const workWarehouse = root.workWarehouse
    ?? root.warehouse
    ?? null;

  return {
    workWarehouse,
    materials,
    isEmpty: materials.length === 0,
  };
}

/**
 * @deprecated 勿再 fallback mock；請直接用 {@link normalizeStockIssueCandidates}。
 */
export function resolveOutboundCandidates(apiPayload) {
  return {
    ...normalizeStockIssueCandidates(apiPayload),
    fromMock: false,
  };
}

export function buildOutboundDraftLine(material, source, qty) {
  const isPending = source.sourceType === 'PENDING_ALLOCATION';
  return {
    sourceKey: source.sourceKey,
    sourceType: source.sourceType,
    invStockId: isPending ? null : source.id,
    pendingAllocationId: isPending ? source.id : null,
    mtrId: material.mtrId,
    mtrNo: material.mtrNo,
    mtrName: material.mtrName,
    stockNo: source.stockNo,
    availableQty: source.qty,
    qty,
  };
}
